export const types = {
    click: '[card] click',
    random: '[card] random',
}